import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as IconStiftungWarentestSeal } from 'media/svg/stiftungWarentestSeal.svg';

import styles from './StiftungWarentest.module.scss';

const StiftungWarentest = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.Banner}>
            <IconStiftungWarentestSeal />
            <div>
                <h3>{t('TRANS-testwinner-at-stiftung-warentest')}</h3>
                <span
                    dangerouslySetInnerHTML={{
                        __html: t('TRANS-check24-is-best-in-class'),
                    }}
                />
            </div>
        </div>
    );
};

export default StiftungWarentest;
